/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgentPairingRequest } from './agentPairingRequest';


export interface AgentPairingCodeDetails { 
    /**
     * Agent Id.
     */
    agent_id?: string;
    /**
     * The ID of the user that zuthorized the pairing.
     */
    authorized_by?: string;
    /**
     * The timestamp at which pairing request was authorized.
     */
    authorized_timestamp?: Date;
    /**
     * The OAuth app client Id created for agent.
     */
    client_id?: string;
    /**
     * AWS Secret Manager reference/key for OAuth app client secret.
     */
    client_secret_sm_ref?: string;
    /**
     * The timestamp at which pairing request was received.
     */
    created_timestamp?: Date;
    /**
     * AWS Secret Manager reference/key for device code.
     */
    device_code_sm_ref?: string;
    /**
     * Organidation Id to which agent is paired.
     */
    paired_org_id?: string;
    raw_request?: AgentPairingRequest;
    /**
     * User code generated to pair agent.
     */
    user_code?: string;
}

